import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=06c64b6a&"
import script from "./Schedule.js?vue&type=script&lang=js&"
export * from "./Schedule.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports